<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="sousTraitanceOui.partValeur?.valeur"
    [label]="step5.getvaleursoustraitance" [type]="'number'" [rule]="'digits_2|min_0'" [errorMessage]="{'required' : 'ctr_334','min': 'part_min'}"
    [name]="getUidTypeMontant() + '_SepAtt_valeur'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="sousTraitanceOui.partValeur?.devise"
    [label]="step5.getdevise" [type]="'autocomplete'"
    [autoCompleteType]="'DEVISE'"
    [autoCompleteTypeIndex]="0"
    [rule]="'pattern_13'"
    [errorMessage]="{}" [name]="getUidTypeMontant() + '_SepAtt_devise'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="sousTraitanceOui.partPct"
    [label]="step5.getpartpct" [type]="'number'" [rule]="'min_0|max_100'" [name]="getUid() + '_SepAtt_partPct'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''" [label]="step5.getpartinconnue"
    [type]="'checkbox'" [rule]="''" [errorMessage]="{'required' : 'ctr_334'}" [name]="getUid() + '_SepAtt_partInconnue'"
    [isChecked]="sousTraitanceOui.partInconnue" [checkboxDestination]="'string'">
</app-form-input>
<app-form-input-error *ngIf="index > 0" [activeForm]="parentForm" [name]="getStepId() + rg1 + index" [id]="getStepId() + rg1 + index"></app-form-input-error>